import React, { Component } from 'react';
import RequestMessage from './RequestMessage';

class RequestToDo extends Component {
    render() {
        return (
            <div className="pane">
                <RequestMessage />
            </div>
        );
    }
}

export default RequestToDo;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestInfo/index.js